import { MinMaxValidatorConfig, ValdrValidator } from '@app/valdr/models';
import { numberValidator } from '@app/valdr/validators/length-validator';
import * as R from 'ramda';

export const minValidator: ValdrValidator = R.curry(({value: minValue}: MinMaxValidatorConfig, value: any) =>
  numberValidator(R.lte(minValue), value)
);
